/* 
  Smooth continuous scrolling for logo slider
  Using proven CSS-only approach: duplicate content and animate to -50%
  This creates a seamless infinite loop without gaps
  iOS Safari rendering fix included
*/
(function() {
    'use strict';
    
    // Force iOS Safari to render elements properly
    const forceIOSRender = () => {
        const tracks = document.querySelectorAll('.ia-logo-slider__track');
        tracks.forEach(track => {
            // Force a repaint on iOS Safari
            void track.offsetHeight;
            track.style.display = 'none';
            void track.offsetHeight;
            track.style.display = 'flex';
            
            // Ensure all children are visible
            const items = track.querySelectorAll('.ia-logo-slider__item, .ia-logo-slider__item img');
            items.forEach(item => {
                item.style.opacity = '1';
                item.style.visibility = 'visible';
                item.style.webkitOpacity = '1';
                item.style.webkitVisibility = 'visible';
            });
        });
    };
    
    // Run on load and after a short delay for iOS
    if (document.readyState === 'complete') {
        setTimeout(forceIOSRender, 100);
    } else {
        window.addEventListener('load', () => {
            setTimeout(forceIOSRender, 100);
        });
    }
    
    // Also run on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(forceIOSRender, 200);
        });
    } else {
        setTimeout(forceIOSRender, 200);
    }
})();